// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__EE79N","validationTips":"StatementDescriptor_validationTips__KVN-m"};